module.exports = __webpack_public_path__ + "img/EconomyTechBackgroundC06_ua.a9adf105.webp";